import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import { z } from "zod";

type Email = {
    readonly _type: "EMAIL";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly emailAddress: string;
    readonly verified: boolean;
    readonly categoryTags: string[];
};

type FactoryParams = Except<Email, "_type" | "_createdAt" | "categoryTags">;

const emailFactory = (
    params: FactoryParams & { categoryTags?: string[] },
): Email => {
    return {
        ...params,
        _type: "EMAIL",
        _createdAt: nowIsoAndUnix(),
        categoryTags: params.categoryTags || [],
    };
};

const emailZodSchema: z.ZodSchema<Email> = z.object({
    _type: z.literal("EMAIL"),
    _createdAt: isoAndUnixZodSchema,
    emailAddress: z.string().email(),
    verified: z.boolean(),
    categoryTags: z.array(z.string()),
});

const emailTags = {
    owner: {
        tag: "owner",
    },
    public: {
        tag: "public",
        description: "can be provided to end customers",
    },
    order: {
        tag: "order",
        description: "used for orders",
    },
};

const anonymizeEmail = (email: Email): Email => {
    return {
        ...email,
        emailAddress: "####@####.se",
        verified: false,
    };
};

export { anonymizeEmail, emailFactory, emailTags, emailZodSchema };
export type { Email };
